export interface CommissionsByProductTypeState {
  isCreateModalOpen: boolean
  isEditModalOpen: boolean
  selectedId: string | null
}

export const initialState: CommissionsByProductTypeState = {
  isCreateModalOpen: false,
  isEditModalOpen: false,
  selectedId: null
}
